import { render, staticRenderFns } from "./designer-detail-filter.vue?vue&type=template&id=080b52ba&scoped=true"
import script from "./designer-detail-filter.vue?vue&type=script&lang=js"
export * from "./designer-detail-filter.vue?vue&type=script&lang=js"
import style0 from "./designer-detail-filter.vue?vue&type=style&index=0&id=080b52ba&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "080b52ba",
  null
  
)

export default component.exports